import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLoomComponent } from './simple-icons-loom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLoomComponent ],
    exports:      [ SimpleIconsLoomComponent ],
    bootstrap:    []
})
export class SimpleIconsLoomModule {}
